import { Link } from "react-router-dom";
import { PRODUCTS, DIVISIONS } from "../data/content";
import { Reveal } from "./Reveal";

// Current factual operating statuses — ordered by the locked hierarchy:
// commercial products, Turf Talk, operating digital business, live Labs products,
// developing initiatives, structural. No vanity metrics.
export const NowStrip = () => {
    const retail = DIVISIONS.find((d) => d.testId === "division-retail");
    const commercial = ["warroom-storecentral", "control-shift", "warroom-ai"].map((slug) =>
        PRODUCTS.find((p) => p.slug === slug),
    );
    const hoteltrips = PRODUCTS.find((p) => p.slug === "hoteltrips");
    const items = [
        ...commercial.map((p) => ({ name: p.name, status: p.status })),
        { name: "Turf Talk", status: "Closed Beta", to: "/portfolio/turf-talk-2", testId: "now-strip-turf-talk" },
        { name: hoteltrips.name, status: hoteltrips.status },
        { name: "Bud's Market Intelligence Desk", status: "Live", to: "/portfolio/bud", testId: "now-strip-bud" },
        { name: "C.A.R.T.-Right Fund", status: "In Development" },
        { name: "THG Retail", status: retail.statusNote },
    ].filter((i) => i.status);
    return (
        <section className="border-b border-thg-border bg-[#0d0d0d]" data-testid="now-strip">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <Reveal>
                    <p className="text-[10px] tracking-[0.25em] uppercase font-bold text-thg-tertiary">
                        <span className="text-thg-red mr-2">&#9632;</span>Now at Titan Haven
                    </p>
                    <div className="mt-4 flex flex-wrap gap-x-8 gap-y-3">
                        {items.map((i) =>
                            i.to ? (
                                <Link
                                    key={i.name}
                                    to={i.to}
                                    data-testid={i.testId}
                                    className="flex items-baseline gap-2 text-sm text-thg-secondary hover:text-white transition-colors duration-300"
                                >
                                    {i.name}
                                    <span className="text-[10px] tracking-[0.15em] uppercase text-thg-tertiary">{i.status}</span>
                                </Link>
                            ) : (
                                <span key={i.name} className="flex items-baseline gap-2 text-sm text-thg-secondary">
                                    {i.name}
                                    <span className="text-[10px] tracking-[0.15em] uppercase text-thg-tertiary">{i.status}</span>
                                </span>
                            ),
                        )}
                    </div>
                </Reveal>
            </div>
        </section>
    );
};
